var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.91 5l-5.5 5L.2 8.9 4.49 5 .2 1.1 1.41 0z"}));
}

ChevronRight.defaultProps = {};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
